import script from "./ChangeThePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeThePassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangeThePassword.vue?vue&type=style&index=0&id=1b187da2&lang=css"

const __exports__ = script;

export default __exports__